import { render } from "./Payment.vue?vue&type=template&id=bd894526"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/Payment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bd894526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bd894526', __exports__)) {
    api.reload('bd894526', __exports__)
  }
  
  module.hot.accept("./Payment.vue?vue&type=template&id=bd894526", () => {
    api.rerender('bd894526', render)
  })

}


export default __exports__